import React, { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Paper, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as TI404Icon } from './icons/TimeIntelligence_404_Icon.svg';
import { useGoToHome } from './hooks/useGoToHome';
import { useErrorPageStyles } from './hooks/useErrorPageStyles';
import ZeroTime_Logo_Error_Pages from './logo/ZeroTime_Logo_Error_Pages.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(4, 4, 0, 0),
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadow?.paper,
    minHeight: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    textAlign: 'center'
  },
  subTitleText: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('xl')]: {
      fontSize: '3vh',
      marginBottom: theme.spacing(2)
    },
    [theme.breakpoints.down('xl')]: {
      fontSize: '3vh',
      marginBottom: theme.spacing(2)
    }
  }
}));

const ErrorPage_404 = (): ReactElement => {
  const classes = useStyles();
  const { goToHome } = useGoToHome();
  const errorPageClasses = useErrorPageStyles();

  return (
    <Paper
      data-testid="error-page-404"
      className={classes.root}
      square
      elevation={0}
    >
      <img src={ZeroTime_Logo_Error_Pages} alt="Zt Logo" />
      <TI404Icon className={errorPageClasses.icon} />
      <Typography variant="h2" className={errorPageClasses.titleText}>
        <FormattedMessage id="errorPage._404.title" />
      </Typography>
      <Typography variant="h6" className={errorPageClasses.subTitleText}>
        <FormattedMessage id="errorPage._404.subText" />
      </Typography>
      <Button
        className={errorPageClasses.button}
        color="primary"
        variant="contained"
        onClick={goToHome}
        size="large"
      >
        <FormattedMessage id="errorPage._404.buttonText" />
      </Button>
    </Paper>
  );
};

export default ErrorPage_404;
